import type { ObjectValues } from 'utils/types';

export const WithdrawalReason = {
	SOLD_OTHER: 'soldOther',
	SOLD_SBAZAR: 'soldSbazar',
	UNSPECIFIED: 'notSpecified',
} as const;
export type WithdrawalReason = ObjectValues<typeof WithdrawalReason>;
